import PostCreate from "./PostCreate";
export default PostCreate;
